import { Component, Input } from "@angular/core";
import { ViewDetailsComponent } from "../../../view-details/view-details.component";
import { ActivityLogTimelineComponent } from "../../../activity-log-timeline/activity-log-timeline.component";
import { NoDataComponent } from "../../../no-data/no-data.component";
import { InventoryService } from "../../../../services/inventory-service";
import { LoadingService } from "../../../../services/loading.service";
import { CONTAINER_VIEW_PAGE_CONFIG } from "../config/container-view.config";

@Component({
  selector: 'app-container-activity-log',
  standalone: true,
  imports: [
    ViewDetailsComponent,
    ActivityLogTimelineComponent,
    NoDataComponent
  ],
  templateUrl: './container-activity-log.component.html',
  styleUrl: './container-activity-log.component.scss'
})
export class ContainerActivityLogComponent {
  containerMeta = CONTAINER_VIEW_PAGE_CONFIG.tableMeta
  containerData!: any;

  @Input() containerId: string = '';

  constructor(private inventoryService: InventoryService,
              private loadingService: LoadingService){

  }

  ngOnInit(): void {
    this.getContainerActivityLog();
  }

  getContainerActivityLog() {
    if (!this.containerId) {
      console.error("Container ID is not provided.");
      return;
    }
    this.loadingService.show();
    this.inventoryService.getContainerActivity(this.containerId).subscribe({
      next: (res: any) => {
        this.containerData = res.data;
        this.postProcessData(this.containerData);
        this.loadingService.hide();
      },
      error: (err) => {
        console.error("Error fetching container data:", err);
        this.loadingService.hide();
      }
    });
  }

  private postProcessData(container: any) {
    const itemList = container.documentDetails;
    if (!itemList) return;
    
    // Extract unique blNos from documentDetails
    const blNoList = itemList
      .map((doc: any) => doc?.blNo)
      .filter((blNo: string) => blNo && blNo.trim());
    
    // Set unique blNos to container
    container.blNos = [...new Set(blNoList)];
  }
}
